import { RxInfoCircled } from '@react-icons/all-files/rx/RxInfoCircled'
import React from 'react'

import {
  selectCanToggleSearchEngine,
  setSearchEngine,
} from '@disco/state-management/reducers/search-page'

import type { SearchEngine } from 'types/search-page'

import {
  AccessibleIcon,
  Flex,
  SegmentedControl,
  Text,
  Tooltip,
} from 'components/ds'

import { useDispatch, useSelector } from 'hooks/use-redux'

const isSearchEngine = (value: string): value is SearchEngine =>
  value === 'disco' || value === 'aims'

/**
 * PLT-880: staff-only switch between DISCO and AIMS for prompt and similarity
 * searches, so staff can re-run the same search on each engine and compare.
 */
const SearchEngineToggle = (): React.ReactNode => {
  const dispatch = useDispatch()
  const canToggle = useSelector(selectCanToggleSearchEngine)
  const searchEngine = useSelector(state => state.searchPage.searchEngine)

  if (!canToggle) return null

  return (
    <Flex align="center" gap="2">
      <Tooltip content="Staff only: compare results between DISCO and AIMS">
        <Text color="red" asChild>
          <Flex tabIndex={0}>
            <AccessibleIcon label="Staff only">
              <RxInfoCircled />
            </AccessibleIcon>
          </Flex>
        </Text>
      </Tooltip>
      <SegmentedControl.Root
        size="2"
        value={searchEngine}
        onValueChange={value => {
          if (isSearchEngine(value)) dispatch(setSearchEngine(value))
        }}
        aria-label="Search engine"
      >
        <SegmentedControl.Item value="disco">DISCO</SegmentedControl.Item>
        <SegmentedControl.Item value="aims">AIMS</SegmentedControl.Item>
      </SegmentedControl.Root>
    </Flex>
  )
}

export default SearchEngineToggle
